import AlertList from './AlertList';
import AlertShow from './AlertShow';
import AddToHomeScreenIcon from '@material-ui/icons/AddToHomeScreen';

export default {
  list: AlertList,
  show: AlertShow,
  icon: AddToHomeScreenIcon,
};
